import { SvgIcon, SvgIconProps } from './SvgIcon';

export const SparkleIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 6.5C12.1569 6.5 13.5 5.15685 13.5 3.5C13.5 5.15685 14.8431 6.5 16.5 6.5C14.8431 6.5 13.5 7.84315 13.5 9.5C13.5 7.84315 12.1569 6.5 10.5 6.5ZM2.5 11.5C5.81371 11.5 8.5 8.81371 8.5 5.5C8.5 8.81371 11.1863 11.5 14.5 11.5C11.1863 11.5 8.5 14.1863 8.5 17.5C8.5 14.1863 5.81371 11.5 2.5 11.5Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
